import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreDtwinStateApplyCopiedConfig',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    dtwinId: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: function () {
    return {
      copyItems: {
        title: 'properties.title',
        key: 'key',
        unit: 'properties.unit',
        faIcon: 'properties.faIcon',
        linkGeoCoordinate: 'properties.linkGeoCoordinate',
        geoCoordinateKey: 'properties.geoCoordinateKey',
        bindingType: 'properties.binding.type',
        valueType: 'properties.valueType',
        visualization: 'properties.visual',
        transformer: 'properties.binding.transformer.script'
      },
      valuesToCopy: {},
      // the v-model for the UI-checkbox
      // needs to be an own model, to react to input-events,
      // otherwise ONLY the title can be clicked but not the checkbox itself....
      areAllItemsSelected: true
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    copyConfig() {
      return this.$store.state.app.dtwinStateConfigCopy;
    },
    copyItemsKeys() {
      // return Object.keys(this.copyItems).filter((k) => {
      //   return this.isDifferentTwin || ['title', 'key'].indexOf(k) < 0;
      // });
      return Object.keys(this.copyItems);
    },
    allItemsSelected() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.areAllItemsSelected = Object.values(this.valuesToCopy).filter(v => !v).length === 0;
      return this.areAllItemsSelected;
    },
    isDifferentTwin() {
      if (!this.dtwinId) {
        return;
      }
      return this.dtwinId !== (this.copyConfig || {}).dtwinId;
    }
  },
  watch: {
    isOpen() {
      this.setup();
    }
  },
  mounted() {
    this.setup();
  },
  methods: {
    setup() {
      const valuesToCopy = {};
      this.copyItemsKeys.forEach(k => {
        valuesToCopy[k] = true;
      });
      this.valuesToCopy = valuesToCopy;
      this.valuesToCopy = cloneDeep(this.valuesToCopy);
    },
    toggleAllItems() {
      const toggledState = !this.allItemsSelected;
      this.copyItemsKeys.forEach(k => {
        this.valuesToCopy[k] = toggledState;
      });
      this.valuesToCopy = cloneDeep(this.valuesToCopy);
      this.areAllItemsSelected = this.allItemsSelected;
    },
    refresh() {
      // to force e.g. the `allItemsSelected` comp-value to be re-calculated, clone the whole shizzle
      this.valuesToCopy = cloneDeep(this.valuesToCopy);
      this.areAllItemsSelected = this.allItemsSelected;
    },
    applyStateConfig() {
      let pathsToCopy = [];
      this.copyItemsKeys.forEach(k => {
        if (this.valuesToCopy[k]) {
          pathsToCopy.push(this.copyItems[k]);
        }
      });
      this.$emit('apply', pathsToCopy);
    },
    close(errorMessage) {
      this.$emit('close', errorMessage);
    }
  }
};